module.exports = __webpack_public_path__ + "img/pomodoro.bccc7fc6.png";